import React from 'react';
import PropTypes from 'prop-types';
import { Container, Stack } from '@mui/material';
import { LoadingScreen } from 'src/components/loading-screen';
import { useCandidateProfileContext } from '../hooks/use-candidate-profile-context';

export default function CandidateProfileLayout({ children }) {
  // hooks
  const { isLoading } = useCandidateProfileContext();

  return (
    <>
      {isLoading && (
        <Stack
          position="absolute"
          top={0}
          right={0}
          left={0}
          bottom={0}
          height="100vh"
          alignItems="center"
          justifyContent="center"
        >
          <LoadingScreen />
        </Stack>
      )}
      <Container
        sx={{
          minHeight: '100vh',
          px: {
            xs: '12px',
            md: '0px',
          },
        }}
      >
        {children}
      </Container>
    </>
  );
}

CandidateProfileLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
